import React, {PureComponent} from 'react';
import moment from 'jalali-moment'
import DatePicker from 'react-datepicker2';

export default class DatePickerField extends PureComponent {

    constructor(props) {
        super(props);
    }

    onChange = val => {
        const { input } = this.props;
        input.onChange(val);
    };

    render() {
        const {
            input,
            meta: { touched, error, warning },
            placeholder,
            disabled,
            timePicker
        } = this.props;

        return (
            <DatePicker
                timePicker={timePicker}
                isGregorian={false}
                className="datePicker"
                disabled={disabled}
                placeholder={placeholder}
                onChange={input.onChange}
            />

        );
    }
}



